import {Component, OnInit, signal} from '@angular/core';
import {SortingComponent} from '../sorting.component';
import {User} from '../classes/user.class';
import {Router, RouterLink} from '@angular/router';
import {CordovaService} from '../cordova.service';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {LocalStorage} from '../storage.class';
import {DatePipe, formatDate} from '@angular/common';
import {SmallMaterialStatus} from '../smallmaterial-status';
import {SmallMaterialRequest} from '../smallmaterial-request';
import {SmallMaterialService} from '../services/small-material.service';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";
import {SortingIconComponent} from "../sorting-icon.component";
import {MatRipple} from "@angular/material/core";

@Component({
    selector: 'app-small-material-request',
    templateUrl: './small-material-request.component.html',
    styleUrls: ['./small-material-request.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        MatButton,
        MatFormField,
        MatSelect,
        FormsModule,
        MatOption,
        SortingIconComponent,
        MatRipple,
        DatePipe,
        MatIconButton
    ]
})
export class SmallMaterialRequestComponent extends SortingComponent<SmallMaterialRequest> implements OnInit {

    user: User;
    statusIds = [1, 2, 4, 8];
    readonly statusList = signal<SmallMaterialStatus[]>([]);
    showStatusFilter = true;

    constructor(
        private router: Router,
        private cordovaService: CordovaService,
        private confirmDialog: ConfirmDialogService,
        private smallMaterialService: SmallMaterialService
    ) {
        super();
    }

    ngOnInit(): void {
        this.currentSort.update(() => 'created_at');
        this.desc.update(() => true);

        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
        if (!AuthorisationService.hasFeature('smallMaterialManagement')) {
            this.statusIds = [1, 2, 3, 4, 5, 6, 7, 8];
            this.showStatusFilter = false;
        }
        this.getData();
        this.user = LocalStorage.getUser();
        this.smallMaterialService.statusList().subscribe(status => {
            this.statusList.set(status.data);
        });
    }

    public getData() {
        this.smallMaterialService.listRequests(this.statusIds).subscribe(requests => {
            this.list.set(requests.data);
        });
    }

    delete(event, smallMaterialRequest: SmallMaterialRequest) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Aanvraag intrekken',
            `Weet u zeker dat u deze aanvraag aangemaakt op ${formatDate(smallMaterialRequest.created_at, 'd MMM yyyy, H:mm', 'nl')} wilt intrekken?`,
            'Intrekken',
            'Behouden'
        ).then(() => {
            this.smallMaterialService.deleteRequest(smallMaterialRequest.id).subscribe(() => {
                const index = this.list().indexOf(smallMaterialRequest);
                this.list().splice(index, 1);
            });
        }, () => {

        });
    }

}
